import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Cancel as CancelIcon, Save as SaveIcon } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { closeEditDialog, updateTranslationAsync } from '../store/slices/translationsSlice';
import { selectEditingTranslation, selectIsEditDialogOpen } from '../store/selectors/translationsSelectors';

const EditTranslationDialog: React.FC = () => {
    const dispatch = useAppDispatch();
    const editingTranslation = useAppSelector(selectEditingTranslation);
    const editDialogOpen = useAppSelector(selectIsEditDialogOpen);

    const [editingText, setEditingText] = useState('');

    // Update editingText when editingTranslation changes
    useEffect(() => {
        if (editingTranslation) {
            setEditingText(editingTranslation.translatedString || '');
        }
    }, [editingTranslation]);

    const saveEditing = () => {
        if (!editingTranslation) return;

        // Mock current user - in a real app, this would come from authentication
        const currentUser = 'Current User';

        // Format current date and time
        const now = new Date();
        const formattedDateTime = now.toISOString();

        dispatch(updateTranslationAsync({
            id: editingTranslation.translationRecordId,
            valueInReview: editingText,
            updatedBy: currentUser,
            date: formattedDateTime,
        }));
    };

    const cancelEditing = () => {
        dispatch(closeEditDialog());
    };

    return (
        <Dialog open={editDialogOpen} onClose={cancelEditing} maxWidth="md" fullWidth>
            <DialogTitle>Edit Translation</DialogTitle>
            <DialogContent>
                <Box sx={styles.dialogContent}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        English:
                    </Typography>
                    <Typography variant="body1" sx={styles.englishTextBox}>
                        {editingTranslation?.originalString}
                    </Typography>

                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Spanish:
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        value={editingText}
                        onChange={(e) => setEditingText(e.target.value)}
                        variant="outlined"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancelEditing} startIcon={<CancelIcon />}>
                    Cancel
                </Button>
                <Button onClick={saveEditing} variant="contained" startIcon={<SaveIcon />}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const styles = {
    dialogContent: {
        mt: 2,
    },
    englishTextBox: {
        mb: 2,
        p: 2,
        bgcolor: 'grey.50',
        borderRadius: 1,
    },
};

export default EditTranslationDialog;
